export const NAV = {
  logo: 'nav-logo',
  linkShop: 'nav-link-shop',
  linkGoal: 'nav-link-goal',
  linkQuiz: 'nav-link-quiz',
  linkIngredients: 'nav-link-ingredients',
  linkReviews: 'nav-link-reviews',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
  ctaShop: 'nav-cta-shop',
};

export const HERO = {
  root: 'hero-section',
  headline: 'hero-headline',
  sub: 'hero-sub',
  ctaPrimary: 'hero-cta-shop',
  ctaSecondary: 'hero-cta-quiz',
};

export const SHOP = {
  root: 'shop-favourites',
  card: (slug) => `product-card-${slug}`,
  cta: (slug) => `product-cta-${slug}`,
};

export const GOAL = {
  root: 'shop-by-goal',
  card: (slug) => `goal-card-${slug}`,
  scroller: 'goal-scroller',
  prev: 'goal-prev',
  next: 'goal-next',
};

export const QUIZ = {
  root: 'tea-quiz',
  option: (slug) => `quiz-option-${slug}`,
  next: 'quiz-next',
  restart: 'quiz-restart',
  result: 'quiz-result',
  progress: 'quiz-progress',
};

export const ING = {
  root: 'hero-ingredients',
  card: (slug) => `ingredient-card-${slug}`,
  dictLink: 'ingredients-dict-link',
};

export const REVIEWS = {
  root: 'reviews-section',
  stat: (slug) => `review-stat-${slug}`,
};

export const FOOTER = {
  root: 'footer',
};

export const DICT = {
  root: 'ingredient-dictionary',
  card: (slug) => `dict-card-${slug}`,
  back: 'dict-back',
};
